import React, { useState, useRef, useEffect } from "react";
import PricingCard from "../../molecules/PricingCard/PricingCard";

const Pricing: React.FC = () => {
  const pricingPlans = [
    {
      title: "ŠTANDARD",
      price: 20,
      features: [
        "40+ predpripravených vyšetrení",
        "Neobmedzený počet dekurzov",
        "Možnosť výberu špecializácie",
        "Nastavenie vzhľadu na mieru",
      ],
    },
    {
      title: "PREMIUM",
      price: 30,
      features: [
        "Všetky ŠTANDARD funkcie",
        "Vytváranie vlastných vyšetrení",
        "Úprava existujúcich šablón",
        "Prispôsobenie systému podľa vlastných potrieb",
      ],
      isPopular: true,
    },
  ];

  const [activeSlide, setActiveSlide] = useState(1); // Start with the middle card active
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (cardsRef.current && window.innerWidth <= 1243) {
        const container = cardsRef.current;
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;

        // Calculate maximum scrollable distance
        const maxScroll = scrollWidth - clientWidth;

        if (maxScroll <= 0) {
          setActiveSlide(0);
          return;
        }

        // Calculate scroll percentage (0 to 1)
        const scrollPercentage = scrollLeft / maxScroll;

        // Determine active slide based on scroll position
        // Divide scroll into 3 equal sections for 3 cards
        let newActiveSlide = 0;
        if (scrollPercentage > 0.66) {
          newActiveSlide = 2;
        } else if (scrollPercentage > 0.33) {
          newActiveSlide = 1;
        } else {
          newActiveSlide = 0;
        }

        setActiveSlide(newActiveSlide);
      }
    };

    const cardsElement = cardsRef.current;
    if (cardsElement) {
      cardsElement.addEventListener("scroll", handleScroll, { passive: true });

      if (window.innerWidth <= 1243) {
        setTimeout(() => {
          scrollToSlide(1);
        }, 100);
      }
    }

    return () => {
      if (cardsElement) {
        cardsElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scrollToSlide = (index: number) => {
    if (cardsRef.current && window.innerWidth <= 1243) {
      const container = cardsRef.current;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Calculate target scroll position
      let targetScroll = 0;
      if (index === 1) {
        targetScroll = maxScroll * 0.5;
      } else if (index === 2) {
        targetScroll = maxScroll;
      }

      container.scrollTo({
        left: targetScroll,
        behavior: "smooth",
      });
      setActiveSlide(index);
    }
  };

  return (
    <div className="dui-pricing" id="pricing">
      <div className="dui-pricing-container">
        <h2 className="dui-pricing-heading">
          <span className="desktop-heading">
            Ponuka našich služieb pre{" "}
            <span className="dui-pricing-heading-highlight">
              efektívnejšiu administratívu
            </span>{" "}
            v zdravotnej starostlivosti
          </span>
          <span className="tablet-heading">
            Ponuka našich služieb pre{" "}
            <span className="dui-pricing-heading-highlight">
              efektívnejšiu administratívu
            </span>
            <br />v zdravotnej starostlivosti
          </span>
          <span className="mobile-heading">
            Ponuka našich služieb
            <br />
            pre{" "}
            <span className="dui-pricing-heading-highlight">
              efektívnejšiu administratívu
            </span>
            {/* <br /> */}
          </span>
        </h2>

        <div className="dui-pricing-cards" ref={cardsRef}>
          {pricingPlans.map((plan, index) => (
            <PricingCard
              key={index}
              title={plan.title}
              price={plan.price}
              features={plan.features}
              isPopular={plan.isPopular}
            />
          ))}
        </div>

        <ul className="carousel-indicators">
          {pricingPlans.map((_, index) => (
            <li
              key={index}
              className={index === activeSlide ? "active" : ""}
              onClick={() => scrollToSlide(index)}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Pricing;
